import React from "react";

const NotFound = () => {
  return (
    <div class="flex justify-center items-center h-screen">
      <div class="bg-gray-100 p-8 rounded-lg shadow-md text-center">
        <h1 class="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <h2 class="text-3xl font-bold text-gray-800 mb-4">
          Oops! Something went wrong.
        </h2>
        <p class="text-lg text-gray-600 mb-8">
          Please check the server and try again later.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
